/* eslint-disable react/prop-types */

/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.844 8.164c-.603 0-1.005.405-1.005 1.014v1.42h6.54v-1.42c0-.609-.401-1.014-1.005-1.014h-4.53zM19.132 9.182c0-.608-.403-1.014-1.006-1.014h-4.53c-.603 0-1.006.406-1.006 1.014v1.42h6.542v-1.42z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.624 6.438c0-.302.299-.609.603-.609H19.73c.3 0 .604.302.604.609v4.164h1.81V6.438c0-1.32-1.109-2.438-2.418-2.438H4.231c-1.31.104-2.417 1.118-2.417 2.438v4.164h1.81V6.438zM22.76 11.922H1.21c-.705 0-1.21.509-1.21 1.22v4.165c0 .707.505 1.216 1.206 1.216h1.207v1.221c0 .708.505 1.217 1.206 1.217.702 0 1.207-.509 1.207-1.217v-1.22h14.301v1.22c0 .708.505 1.217 1.207 1.217.706 0 1.21-.509 1.21-1.217v-1.22h1.211c.702 0 1.206-.51 1.206-1.217v-4.164c-.094-.712-.598-1.221-1.202-1.221"
})), 'CategoryCO');